export const useAuthorUrl = (id?: string, name?: string, separator: string = '-'): string => {
  let url = ''
  if (name) {
    url = `${url}${useNormalizeString(name)}${separator}`
  }
  url = `${url}${useShortItemId(id)}`

  return url.replace(/[ ]/g, separator)
}
